/* React */
import React from "react";

/* Ionic */
import { IonInput, IonIcon } from "@ionic/react";

/* React-Hook-Form */
import {
  FieldErrors,
  FieldValues,
  UseFormClearErrors,
  UseFormRegister,
} from "react-hook-form";

/* Components */
import FilterLabel from "src/components/shared/labels/filter-label/FilterLabel";

/* Stylesheet */
import styles from "./FormInput.module.scss";

/* Interfaces */
interface FormInputProps {
  testId?: string;
  scssProps?: ScssProps;
  register?: ReturnType<UseFormRegister<FieldValues>>;
  errors?: FieldErrors;
  clearErrors?: UseFormClearErrors<FieldValues>;
  type: "text" | "password" | "number";
  name: string;
  label?: string;
  placeholder: string;
  value: string | number;
  icon?: string;
  disabled?: boolean;
  onChange: (name: string, value: string) => void;
}

interface ScssProps {
  fontSize?: string;
}

const FormInput: React.FC<FormInputProps> = ({
  testId,
  scssProps,
  register,
  errors,
  clearErrors,
  type,
  name,
  label,
  placeholder,
  value,
  icon,
  disabled,
  onChange,
}) => {
  return (
    <>
      {label ? (
        <FilterLabel
          scssProps={{
            margin: "0px 0px 12px 16px",
            color: "var(--ion-color-text-primary)",
          }}
          label={label}
        />
      ) : undefined}
      <div
        style={{
          margin: errors?.[name]
            ? "12px 0px 12px 0px"
            : "18px 0px 18px 0px",
        }}
        className={styles.form_input}
      >
        {icon ? (
          <div className={styles.icon_container}>
            <IonIcon
              style={{
                color: errors?.[name]
                  ? "var(--ion-color-error)"
                  : undefined,
              }}
              className={styles.icon}
              icon={icon}
            />
          </div>
        ) : undefined}
        <IonInput
          {...register}
          key={name}
          data-cy={testId}
          style={{
            "--padding-start": !icon ? "21px" : undefined,
            color: disabled
              ? "var(--ion-color-disabled)"
              : errors?.[name]
              ? "var(--ion-color-error)"
              : undefined,
            fontSize: scssProps?.fontSize,
          }}
          className={`${styles.input} input`}
          autocomplete="off"
          aria-label={placeholder}
          type={type}
          placeholder={placeholder}
          value={value}
          disabled={disabled}
          onIonInput={(e: CustomEvent) => {
            const inputValue = e.detail?.value || "";
            onChange(name, inputValue);
            clearErrors?.(name);
          }}
          onIonChange={() => clearErrors?.(name)}
        />
      </div>
      {errors?.[name] && (
        <div className={styles.error_message}>
          {errors[name]?.message as React.ReactNode}
        </div>
      )}
    </>
  );
};

export default FormInput;
